// Sidebar navigation item component
// Created as part of ENG2-1699: Create AppLayout Component with Sidebar

import React from 'react'
import { Box, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { tokens } from '../../styles/tokens'
import { SidebarNavItemProps } from './sidebar.types'

const SidebarNavItem: React.FC<SidebarNavItemProps> = ({ item, isActive }) => {
  const { label, icon, path, badge, disabled } = item

  const content = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '10px 14px',
        borderRadius: `${tokens.radius.md}px`,
        fontSize: '14px',
        fontWeight: 500,
        color: isActive ? tokens.colors.primary[400] : 'rgba(255, 255, 255, 0.65)',
        backgroundColor: isActive ? 'rgba(255, 192, 0, 0.15)' : 'transparent',
        transition: `all ${tokens.transitions.fast}`,
        marginBottom: '2px',
        position: 'relative',
        whiteSpace: 'nowrap',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        '&:hover': disabled
          ? {}
          : {
              backgroundColor: isActive
                ? 'rgba(255, 192, 0, 0.15)'
                : 'rgba(255, 255, 255, 0.08)',
              color: isActive ? tokens.colors.primary[400] : '#FFFFFF',
            },
        // Active indicator
        '&::before': isActive
          ? {
              content: '""',
              position: 'absolute',
              left: 0,
              top: '6px',
              bottom: '6px',
              width: '3px',
              backgroundColor: tokens.colors.primary[500],
              borderRadius: '0 3px 3px 0',
            }
          : {},
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          width: 20,
          textAlign: 'center',
          fontSize: '15px',
          flexShrink: 0,
        }}
      >
        <FontAwesomeIcon icon={icon} />
      </Box>

      {/* Label */}
      <Typography
        component="span"
        sx={{
          flex: 1,
          fontSize: 'inherit',
          fontWeight: 'inherit',
          color: 'inherit',
        }}
      >
        {label}
      </Typography>

      {/* Badge */}
      {badge !== undefined && (
        <Box
          sx={{
            marginLeft: 'auto',
            backgroundColor: tokens.colors.primary[500],
            color: tokens.colors.grey[900],
            fontSize: '11px',
            fontWeight: 700,
            padding: '1px 7px',
            borderRadius: '10px',
          }}
        >
          {badge}
        </Box>
      )}
    </Box>
  )

  if (disabled) {
    return content
  }

  return (
    <Link to={path} style={{ textDecoration: 'none' }}>
      {content}
    </Link>
  )
}

export default SidebarNavItem
